import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    step: -1,
    projectId: -1
  },
  mutations: {
    setProjectId(state, projectId) {
      Vue.set(state, 'projectId', projectId);
    },
    setStep(state, step) {
      Vue.set(state, 'step', step);
    }
  },
  getters: {
    getProjectId: state => {
      return state.projectId;
    },
    getStep: state => {
      return state.step;
    }
  },
  actions: {
    setProjectId(context, {id}) {
      context.commit('setProjectId', id);
    },
    setStep(context, {step}) {
      context.commit('setStep', step);
    }
  }
}




// WEBPACK FOOTER //
// ./src/store/ahatutorial.js